<template>
    <div class="vh-100">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="backtoriwayat">
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Preview Faktur Gaji</div>
                <div class="header-top--right">
                    <div class="header-item">
                    </div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page">

            <div class="p-y-16 p-x-20 w-limit">
                <div class="d-flex justify-content-between f-16">
                    <div class="f-c-midgrey">No. Faktur</div>
                    <div class="f-c-black">{{idpembayarangaji}}</div>
                </div>
                <div class="d-flex justify-content-between f-16">
                    <div class="f-c-midgrey">Karyawan</div>
                    <div class="f-c-black">{{detail.nama_karyawan}}</div>
                </div>
	            <div class="d-flex justify-content-between f-16" v-if="detail.outlet_name != ''">
		            <div class="f-c-midgrey">Bekerja di Outlet</div>
		            <div class="f-c-black">{{detail.outlet_name}}</div>
	            </div>
	            <div class="d-flex justify-content-between f-16" v-if="detail.workshop_name != ''">
		            <div class="f-c-midgrey">Bekerja di Workshop</div>
		            <div class="f-c-black">{{detail.workshop_name}}</div>
	            </div>
                <!--                <div class="d-flex m-t-12 justify-content-between f-16">-->
                <!--                    <div class="f-c-midgrey">Pekerjaan</div>-->
                <!--                    <div class="f-c-black">Kasir<span class="f-c-midgrey"> Outlet </span>Dreamwash</div>-->
                <!--                </div>-->
                <div class="d-flex m-t-12 justify-content-between f-16">
                    <div class="f-c-midgrey">Periode</div>
                    <div class="f-c-black">{{detail.periode_format}}</div>
                </div>
            </div>

            <div class="separator"></div>

            <div class="p-x-20 p-t-16 p-d-10 w-limit">
                <!-- GAJI -->
                <div class="section-gaji" v-if="detail.pembayaran_gaji_jenis.length>0">
                    <div class="f-c-16 f-bold">Gaji</div>
                    <div class="item-gaji--wrapper m-t-6">

                        <div class="item-gaji d-flex justify-content-between align-items-center"
                             v-for="jenis in detail.pembayaran_gaji_jenis">
                            <div class="item-gaji--left">
                                <div class="f-14">{{jenis.nama}}</div>
                                <div class="f-12 f-c-midgrey">{{jenis.nominal | currency}} x {{jenis.jumlah}} periode
                                </div>
                            </div>
                            <div class="item-gaji--right d-flex">
                                <div class="f-14">{{jenis.total_gaji |currency }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <br>
                <div class="section-gaji" v-if="detail.upah_borongan.length>0">
                    <div class="f-c-16 f-bold">Upah Borongan</div>
                    <div class="item-gaji--wrapper m-t-6">

                        <div class="item-gaji d-flex justify-content-between align-items-center"
                             v-for="upah in detail.upah_borongan">
                            <div class="item-gaji--left">
                                <div class="f-14">{{upah.nama_tahapan}}</div>
                                <div class="f-12 f-c-midgrey">Dari {{upah.satuan_kuantitas.length}} Layanan</div>
                            </div>
                            <div class="item-gaji--right d-flex">
                                <div class="f-14">{{upah.total_gaji |currency }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section-gaji" v-if="detail.upah_tahapan.length>0">
                    <div class="f-c-16 f-bold">Upah Borongan</div>
                    <div class="item-gaji--wrapper m-t-6">

                        <div class="item-gaji d-flex justify-content-between align-items-center"
                             v-for="upah in detail.upah_tahapan">
                            <div class="item-gaji--left">
                                <div class="f-14">{{upah.nama_tahapan}}</div>
<!--                                <div class="f-12 f-c-midgrey">Dari {{upah.satuan_kuantitas.length}} Layanan</div>-->
                            </div>
                            <div class="item-gaji--right d-flex">
                                <div class="f-14">{{upah.total_upah |currency }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- KOMISI -->
                <div class="section-komisi m-t-10"
                     v-if="detail.pembayaran_gaji_sales!=null || detail.total_komisi > 0 || detail.pembayaran_gaji_komisi.length > 0">
                    <div class="separator-line-dot"></div>
                    <div class="f-c-16 f-bold m-t-16">Komisi</div>
                    <div class="item-komisi--wrapper m-t-6">

                        <div class="item-komisi d-flex justify-content-between align-items-center"
                             v-if="detail.pembayaran_gaji_sales!=null">
                            <div class="item-komisi--left">
                                <div class="f-14">{{detail.pembayaran_gaji_sales.nama_komisi}}</div>
                                <div class="f-12 f-c-midgrey">{{detail.pembayaran_gaji_sales.persentase}}% dari
                                    {{detail.pembayaran_gaji_sales.total_omset |currency }}
                                </div>
                            </div>
                            <div class="item-komisi--right d-flex">
                                <div class="f-14">{{detail.pembayaran_gaji_sales.total_komisi |currency }}</div>
                            </div>
                        </div>

                        <div class="item-komisi d-flex justify-content-between align-items-center"
                             v-for="komisi in detail.pembayaran_gaji_komisi">
                            <div class="item-komisi--left">
                                <div class="f-14">{{komisi.nama}}</div>
                            </div>
                            <div class="item-komisi--right d-flex">
                                <div class="f-14">{{komisi.nominal |currency }}</div>
                            </div>
                        </div>

                        <div class="item-komisi d-flex justify-content-between align-items-center"
                             v-if="detail.total_komisi > 0 && detail.pembayaran_gaji_komisi.length == 0">
                            <div class="item-komisi--left">
                                <div class="f-14">Komisi Tambahan</div>
                            </div>
                            <div class="item-komisi--right d-flex">
                                <div class="f-14">{{detail.total_komisi |currency }}</div>
                            </div>
                        </div>

                    </div>
                </div>


                <!--                <div class="section-komisi m-t-10" v-if="detail.pembayaran_gaji_sales.length>0">-->
                <!--                    <div class="separator-line-dot"></div>-->
                <!--                    <div class="f-c-16 f-bold m-t-16">Komisi</div>-->
                <!--                    <div class="item-komisi&#45;&#45;wrapper m-t-6">-->

                <!--                        <div class="item-komisi d-flex justify-content-between align-items-center" v-for="sales in detail.pembayaran_gaji_sales">-->
                <!--                            <div class="item-komisi&#45;&#45;left">-->
                <!--                                <div class="f-14">{{sales.nama_komisi}}</div>-->
                <!--                                <div class="f-12 f-c-midgrey">{{sales.persentase}}% dari {{sales.total_omset |currency }}</div>-->
                <!--                            </div>-->
                <!--                            <div class="item-komisi&#45;&#45;right d-flex">-->
                <!--                                <div class="f-14">{{sales.total_komisi |currency }}</div>-->
                <!--                            </div>-->
                <!--                        </div>-->

                <!--                    </div>-->
                <!--                </div>-->

	            <div class="separator-line-dot"></div>
	            <div class="w-limit f-16 m-t-16 mar-bot-12 f-bold d-flex justify-content-between">
		            <div class="">Gaji Kotor</div>
		            <div class="">{{detail.subtotal_gaji | currency}}</div>
	            </div>

                <!-- TANGGUNGAN -->
                <div class="section-tanggungan m-t-10"
                     v-if="detail.pembayaran_tanggungan.length > 0 || detail.nominal_terlambat>0 || detail.total_kasbon > 0 || detail.total_potongan > 0">
                    <div class="separator-line-dot"></div>
                    <div class="f-c-16 f-bold m-t-16">Tanggungan</div>
                    <div class="item-tanggungan--wrapper m-t-6">
                        <div class="item-tanggungan d-flex justify-content-between align-items-center"
                             v-if="detail.jumlah_terlambat > 0 || detail.nominal_terlambat > 0">
                            <div class="item-tanggungan--left">
                                <div class="f-14">Denda Keterlambatan</div>
                                <div class="f-12 f-c-midgrey">Terlambat {{detail.jumlah_terlambat}} Menit</div>
                            </div>
                            <div class="item-tanggungan--right d-flex">
                                <div class="f-14 f-c-red">(-) {{detail.nominal_terlambat | currency}}</div>
                            </div>
                        </div>

                        <div class="item-tanggungan d-flex justify-content-between align-items-center" v-for="tanggungan in detail.pembayaran_tanggungan">
                            <div class="item-tanggungan--left">
                                <div class="f-14">{{tanggungan.nama_tanggungan}}</div>
                                <div class="f-12 f-c-midgrey">{{tanggungan.jenis_tanggungan}} •
                                    {{tanggungan.nominal_bayar | currency}}
                                </div>
                            </div>
                            <div class="item-tanggungan--right d-flex">
                                <div class="f-14 f-c-red">(-) {{tanggungan.nominal_bayar | currency}}</div>
                            </div>
                        </div>

                        <div class="item-tanggungan d-flex justify-content-between align-items-center"
                             v-if="detail.total_kasbon > 0 && detail.pembayaran_tanggungan.length == 0">
                            <div class="item-tanggungan--left">
                                <div class="f-14">Pemabayaran Kasbon</div>
                                <div class="f-12 f-c-midgrey">Kasbon • {{detail.total_kasbon | currency}}</div>
                            </div>
                            <div class="item-tanggungan--right d-flex">
                                <div class="f-14 f-c-red">(-) {{detail.total_kasbon | currency}}</div>
                            </div>
                        </div>

                        <div class="item-tanggungan d-flex justify-content-between align-items-center"
                             v-if="detail.total_potongan > 0 && detail.pembayaran_tanggungan.length == 0">
                            <div class="item-tanggungan--left">
                                <div class="f-14">Pemabayaran Potongan</div>
                                <div class="f-12 f-c-midgrey">Potongan • {{detail.total_potongan | currency}}</div>
                            </div>
                            <div class="item-tanggungan--right d-flex">
                                <div class="f-14 f-c-red">(-) {{detail.total_potongan | currency}}</div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <div class="separator-line-dot w-limit"></div>

            <div class="w-limit p-x-20 p-y-16 f-16 f-bold d-flex justify-content-between" @click="CetakGaji">
                <div class="">Total Gaji Bersih</div>
                <div class="">{{totalGaji | currency}}</div>
            </div>

            <div class="separator-line-dot w-limit"></div>

            <div class="w-limit p-x-20 p-t-16 f-16 f-bold">
                Keterangan / Catatan
            </div>
            <div class="f-13 p-x-20 p-d-24 f-c-midgrey">{{ detail.keterangan }}</div>


            <div class="separator"></div>

           <div class="w-limit p-x-20 p-y-20">
               <div class="btn smart-secondary" data-toggle="modal" data-target="#ekspor-faktur">Ekspor Faktur</div>
           </div>
            <div class="w-limit p-x-20" v-if="validateAccess('payrollHistory.delete')">
                <div class="btn smart-secondary" @click="hapusGaji">Hapus Gaji</div>
            </div>

            <br/>
            <br/>
            <br/>
        </div>

        <!-- MODAL -->
        <div class="modal fade" id="ekspor-faktur" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content">
                    <div class="modal-head w-limit">
                        <div class="modal-head--left"></div>
                        <h5 class="f-16 f-bold">Ekspor Faktur</h5>
                        <div class="modal-head--right" data-dismiss="modal">
                            <img src="../../../assets/img/x2.svg" alt="">
                        </div>
                    </div>
                    <div class="separator-line"></div>
                    <div class="modal-bodyy w-limit w-100">
                        <div class="item-export hov p-x-20 p-y-20 d-flex" @click="eksporFakturGaji">
                            <img src="../../../assets/icons/pdf.svg" alt="">
                            <div class="m-l-20 f-16 flex-1 f-semi">Ekspor sebagai PDF</div>
                            <img src="../../../assets/icons/chevron_right_4.svg" alt="">
                        </div>
                        <div class="separator-line"></div>
                        <div class="item-export hov p-x-20 p-y-20 d-flex" @click="eksporFakturGajiExcel">
                            <img src="../../../assets/icons/excel.svg" alt="">
                            <div class="m-l-20 f-16 flex-1 f-semi">Ekspor sebagai file Excel</div>
                            <img src="../../../assets/icons/chevron_right_4.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'DetailRiwayatGaji',
        props: ['idpembayarangaji'],
        watch: {
            "idpembayarangaji": function (id) {
                if (id !== "") {
                    this.getDetailPembayaran(id)
                }
            },
            immediate: true
        },
        computed: {
            subtotalGaji() {
                let subtotalGaji = 0;
                if (this.detail.pembayaran_gaji_jenis.length > 0) {
                    subtotalGaji += this.detail.pembayaran_gaji_jenis.reduce((sum, listGaji) => {
                        return sum += listGaji.total_gaji;
                    }, 0);

                }
                return subtotalGaji;
            },
            subtotalKomisi() {
                let subtotalGaji = 0;
                if (this.detail.pembayaran_gaji_komisi.length > 0) {
                    subtotalGaji += this.detail.pembayaran_gaji_komisi.reduce((sum, listGaji) => {
                        return sum += listGaji.nominal;
                    }, 0);
                } else {
                    if (this.detail.total_komisi > 0) {
                        subtotalGaji += this.detail.total_komisi
                    }
                }

                if (this.detail.pembayaran_gaji_sales != null) {
                    subtotalGaji += this.detail.pembayaran_gaji_sales.total_komisi
                }

                if (this.detail.upah_borongan.length > 0) {
                    subtotalGaji += this.detail.upah_borongan.reduce((sum, listGajiBorongan) => {
                        return sum += listGajiBorongan.total_gaji;
                    }, 0);
                }
                if (this.detail.upah_tahapan.length > 0) {
                    subtotalGaji += this.detail.upah_tahapan.reduce((sum, listGajiBorongan) => {
                        return sum += listGajiBorongan.total_upah;
                    }, 0);
                }

                return subtotalGaji;
            },
            subtotalTanggungan() {
                let subtotalGaji = 0;
                if (this.detail.pembayaran_tanggungan.length > 0) {
                    subtotalGaji += this.detail.pembayaran_tanggungan.reduce((sum, listGaji) => {
                        return sum += listGaji.nominal_bayar;
                    }, 0);
                } else {
                    if (this.detail.total_kasbon > 0) {
                        subtotalGaji += this.detail.total_kasbon
                    }

                    if (this.detail.total_potongan > 0) {
                        subtotalGaji += this.detail.total_potongan
                    }
                }

                // subtotalGaji += this.detail.nominal_terlambat

                subtotalGaji += this.detail.nominal_terlambat

                return subtotalGaji;
            },
            totalGaji() {
                return this.subtotalGaji + this.subtotalKomisi - this.subtotalTanggungan
            }

        },
        data() {
            return {
                detail: {
                    pembayaran_gaji_jenis: [],
                    upah_borongan: [],
                    upah_tahapan: [],
                    pembayaran_gaji_sales: null,
                    total_komisi: 0,
                    pembayaran_gaji_komisi: [],
                    pembayaran_tanggungan: [],
                    total_potongan: 0,
                    total_kasbon: 0
                },
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },

            }
        },
        mounted() {
            this.getDetailPembayaran(this.idpembayarangaji)

        },
        methods: {
            CetakGaji(){
                window.print()
            },

            backtoriwayat() {
	            $(".modal-backdrop").remove()
	            setTimeout(() => {
		            $("#ekspor-faktur").modal("hide")
	            }, 100)

                this.$emit('back')
            },
            maintenance() {
                this.$toast.warning("Fitur ini sedang dalam tahap pengembangan.")
            },
            async hapusGaji() {
                this.isClicked1 = true

                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
                try {
                    const pembayaranGaji = new FormData()
                    pembayaranGaji.append('id_pembayaran_gaji', this.idpembayarangaji)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/penggajian/hapus_rekap_penggajian', pembayaranGaji, this.requestHeaders);
                    if (response.data.status === true) {
                        this.isClicked1 = false
                        this.backtoriwayat()
                        this.$toast.success('Berhasil menghapus riwayat gaji')
                    } else {
                        this.isClicked1 = false
                        this.$toast.error(response.data.msg)
                    }
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()

                } catch (e) {
                    this.$catch_error_response(e)
                    this.isClicked1 = false
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                }
            },
            async eksporFakturGaji() {
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/ekspor_pdf_faktur_gaji?idpembayarangaji=' + this.idpembayarangaji, this.requestHeaders);
                    if (response.data.status === true) {
                        window.open(response.data.data.link_download, '_blank');
                        this.flutterDownload(response.data.data.link_download)
                        //window.location.href = response.data.data.link_download
                        setTimeout(() => {
                            this.DeleteTemporaryPdf(response.data.data.filename)
                        }, 5000)
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide()
                    } else {
                        this.isClicked1 = false
                        this.$toast.error(response.data.msg)
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide()
                    }

                } catch (e) {
                    this.$catch_error_response(e)
                    this.isClicked1 = false
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                }
            },

            async DeleteTemporaryPdf(filename) {
                try {
                    const form = new FormData()
                    form.append('filename', filename)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/penggajian/meta/delete_temp_pdf_storage', form, this.requestHeaders);
                    if (response.data.status === true) {
                        this.$toast.success("Berhasil mengekspor data faktur gaji karyawan.")
                    } else {
                        this.isClicked1 = false
                        this.$toast.error(response.data.msg)
                    }
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()

                } catch (e) {
                    this.$catch_error_response(e)
                    this.isClicked1 = false
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                }
            },
            async eksporFakturGajiExcel() {
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/ekspor_excel_faktur_gaji?idpembayarangaji=' + this.idpembayarangaji, this.requestHeaders);
                    if (response.data.status === true) {
                        // window.open(response.data.data.link_download, '_blank');
                        window.location.href = response.data.data.link_file_storage
                        this.flutterDownload(response.data.data.link_file_storage)
                        setTimeout(() => {
                            this.DeleteTemporaryExcel(response.data.data.filename)
                        }, 5000)
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide()
                    } else {
                        this.isClicked1 = false
                        this.$toast.error(response.data.msg)
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide()
                    }

                } catch (e) {
                    this.$catch_error_response(e)
                    this.isClicked1 = false
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                }
            },

            async DeleteTemporaryExcel(filename) {
                try {
                    const form = new FormData()
                    form.append('filename', filename)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/penggajian/meta/delete_temp_excel_storage', form, this.requestHeaders);
                    if (response.data.status === true) {
                        this.$toast.success("Berhasil mengekspor data faktur gaji karyawan.")
                    } else {
                        this.isClicked1 = false
                        this.$toast.error(response.data.msg)
                    }
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()

                } catch (e) {
                    this.$catch_error_response(e)
                    this.isClicked1 = false
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                }
            },

            async getDetailPembayaran() {
                this.detail = {};
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()

                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/detail_riwayat_penggajian_karyawan?idpembayarangaji=' + this.idpembayarangaji, this.requestHeaders)
                    if (response.data.status === true) {
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
                        this.detail = response.data.data;
                        $('#loadingSpinnerListPembayaran').hide()
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                }
            },

        }
    }
</script>

<style>
</style>